import { Route, Routes } from '@angular/router';
import { authenticationGuard } from '../shared/security/authentication.guard';
import { AuthenticationService } from '@dop/authentication';
import { ExternalRedirectComponent } from '../shared/security/external-redirect/external-redirect.component';
import { featuresResolver } from './features.resolver';
import { ConfigurationCheckGuard } from '../core/guards/configuration-check.guard';

export const routes: Route = {
  children: [
    {
      path: 'manage',
      loadComponent: () => import('../manage-limit-sets/manage-limit-sets.component').then((c) => c.ManageLimitSetsComponent),
      resolve: { featuresResolver },
      canActivate: [ConfigurationCheckGuard]
    },
    {
      path: 'access-denied',
      loadComponent: () => import('../shared/component/access-denied/access-denied.component').then((c) => c.AccessDeniedComponent),
      resolve: { featuresResolver }
    }
  ]
};

export const rootRoutes: Routes = [
  {
    path: AuthenticationService.redirectRoute,
    component: ExternalRedirectComponent
  },
  {
    path: 'error',
    loadComponent: () => import('../shared/component/error/error.component').then((c) => c.ErrorComponent)
  },
  {
    path: '',
    pathMatch: 'full', // This ensures that an empty path ('') will match the root URL
    redirectTo: '/manage' // Redirects to the /manage route
  },
  {
    path: '',
    loadComponent: () => import('./features.component').then((c) => c.FeaturesComponent),
    resolve: { featuresResolver },
    children: routes.children,
    canMatch: [authenticationGuard]
  }
];
